import React from 'react';
import UiInputText from '../../components/Form/UiInputText';
import UiInputList from '../../components/Form/UiInputList';
import UiInputNumberInteger from '../../components/Form/UiInputNumberInteger';

/**
 * Formulário de Cálculo de Queda de Tensão
 *
 * IMPORTANTE: Segue o mesmo padrão de ContratoForm
 * - Campos são parte de dados.calculoPerda
 * - Usa FormProvider do modal
 * - Não tem submit próprio (submit é no rodapé do modal)
 */
const CalculoQuedaTensaoForm: React.FC = () => {
    const tipoFioList = [
        { id: 1, title: 'Aluminio' },
        { id: 2, title: 'Cobre' },
    ];

    const padraoRedeList = [
        { id: 1, title: 'monofásica - com tensão nominal 220V a 02 fios' },
        { id: 2, title: 'monofásica - com tensão nominal 440/220V a 03 fios' },
        { id: 3, title: 'bifásica - com tensão nominal 380/220V a 03 fios' },
        { id: 4, title: 'trifásica - com tensão nominal 380/220V a 04 fios' },
    ];

    return (
        <div className="row">
            <UiInputNumberInteger size={12} name="dados.calculoPerda.distancia" label="Distância (metros)" />
            <UiInputNumberInteger size={12} name="dados.calculoPerda.bitola" label="Bitola do Fio (mm²)" />
            <UiInputNumberInteger size={12} name="dados.calculoPerda.corrente" label="Disjuntor (Corrente Máxima)" />
            <UiInputList size={12} name="dados.calculoPerda.tipoFio" list={tipoFioList} idField="id" titleField="title" label="Material do Cabo" />
            <UiInputNumberInteger size={12} min={0} max={100} name="dados.calculoPerda.fatorPotencia" label="Fator de Potência (%)" />
            <UiInputList size={12} name="dados.calculoPerda.padraoRede" list={padraoRedeList} idField="id" titleField="title" label="Padrão da Rede" />
            <UiInputText size={12} name="dados.calculoPerda.nomeCabo" label="Nome do Cabo (Opcional)" />
        </div>
    );
};

export default CalculoQuedaTensaoForm;
